<template>
    <div>
        <div role="group">
            <label for="input-live">Jméno:</label>
            <b-form-input id="input-live" v-model="name" :state="nameState" aria-describedby="input-live-help input-live-feedback" placeholder trim></b-form-input>
    
            <b-form-invalid-feedback v-model="name" id="input-live-feedback">délka musí být alespoň 3 znaky</b-form-invalid-feedback>
        </div>
        <div role="group">
            <label for="text">Hodnocení</label>
            <star-rating v-model="rating" :read-only="false" :increment="increment"></star-rating>
            <b-form-input id="text" v-model="hodnoceni" :state="textState" aria-describedby="input-live-help input-live-feedback2" placeholder trim></b-form-input>
    
            <!-- This will only be shown if the preceding input has an invalid state -->
            <b-form-invalid-feedback id="input-live-feedback2">délka musí být alespoň 4 znaky</b-form-invalid-feedback>
    
            <!-- This is a form text block (formerly known as help block) -->
        </div>
        <b-button @click="post()">Odeslat</b-button>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import { VueReCaptcha } from "vue-recaptcha-v3";
import Vue from 'vue'
Vue.use(VueReCaptcha, { siteKey: "6LcfE8AUAAAAAIw-zrtbwYiWGu_kSDV7hwsJLHb1" });

export default {
    components: {
        StarRating
    },
    computed: {
        nameState() {
            return this.name.length > 2 ? true : false;
        },
        textState() {
            return this.hodnoceni.length > 4 ? true : false;
        }
    },
    data: () => {
        return {
            name: "",
            hodnoceni: "",
            rating: 5,
            errors: [],
            increment: 0.5
        };
    },
    props: {
        nameOfRecept: String
    },
    methods: {


        post() {
            console.log(this.name);
            this.$recaptcha("login").then(token => {
                console.log(token); // Will print the token$_GET["token"]
                if (token.length > 0) {
                    axios.get(
                        "https://kucharka.zvara.cz/postComment.php",

                        {
                            params: {
                                name: this.nameOfRecept,
                                json: JSON.stringify({
                                    jmeno: this.name,
                                    text: this.hodnoceni,
                                    rating: this.rating
                                    
                                }),
                                token: token
                            }
                        }
                    ).then(response => {
                        console.log(response.data)
                        if (response.data.success) {
                            alert("komentář přidán")
                        } else {
                            alert("spamere, máš smůlu")
                        }
                    });
                } else {
                    alert("Vyplň recaptchu");
                }
            });

        }
    }
};
</script>